import NewCommonServiceHero from "../../../common/NewCommonServices/NewCommonServiceHero";
import NewCommonServiceForm from "../../../common/NewCommonServices/NewCommonServiceForm";
import NewCommonMoreItService from "../../../common/NewCommonServices/NewCommonMoreItService";
import {
  personalBrandingIcon,
  seoMarketingIcon,
  socialMarketingIcon,
  payPerClickIcon,
  influencerMarketingIcon,
  analyticIcon,
} from "../../../../assets/icons/serviceIcon/index";

const items = [
  {
    name: "Email Campaign Strategy",
    text: "We plan automated campaigns using tools like Mailchimp or Klaviyo, with custom emails that guide, re-engage, and build stronger audience relationships.",
  },
  {
    name: "CRM Setup & Management",
    text: "We set up your CRM system, segment your contacts, automate follow-ups, and manage conversations to make sure no lead goes cold.",
  },
  {
    name: "Newsletter Copy & Design",
    text: "We create newsletters, design clean layouts, and send content your audience enjoys, something they want to open and read.",
  },
];

const otherService = [
  {
    icon: seoMarketingIcon,
    name: "Seo & Content Marketing",
    des: "Get ranked on Google and stay in hearts with content that truly speaks to your people.",
    path: "/seo-content-marketing",
  },
  {
    icon: socialMarketingIcon,
    name: "Social Media Marketing (SMM)",
    des: "Show up where your audience scrolls, shares and starts to trust you.",
    path: "/social-media-marketing",
  },
  {
    icon: payPerClickIcon,
    name: "Pay Per Click",
    des: "Get your brand seen by the right people, right when they’re searching for you.",
    path: "/pay-per-click",
  },
  {
    icon: personalBrandingIcon,
    name: "personal Branding",
    des: "Turn your story, skills, and personality into something people remember and trust.",
    path: "/personal-branding",
  },
  {
    icon: influencerMarketingIcon,
    name: "Influencer & Affiliate Marketing",
    des: "Let others talk about your brand in a way that feels real and relatable.",
    path: "/influencer-marketing",
  },
  {
    icon: analyticIcon,
    name: "Analytics  & Performance Tracking ",
    des: "Know what’s working, what’s not, and what to do next without the guesswork.",
    path: "/analytic-and-performance-tracking",
  },
];

const EmailMarketing = () => {
  return (
    <div className="">
      <NewCommonServiceHero
        colorHeading="Marketing"
        description="Email & CRM Marketing is your silent growth engine. We create and automate email flows that nurture your audience, bring them back, and turn interest into action again and again."
        heading="Email & CRM"
      />
      <NewCommonServiceForm title="Email & CRM Marketing" items={items} />
      <NewCommonMoreItService items={otherService} />
    </div>
  );
};

export default EmailMarketing;
